import type { Document as RichTextDocument } from '@contentful/rich-text-types'
import { BLOCKS } from '@contentful/rich-text-types'

import type { SignUpBaseProps } from '.'

const description: RichTextDocument = {
  content: [
    {
      data: {},
      content: [
        {
          content: [
            {
              content: [
                {
                  data: {},
                  marks: [],
                  nodeType: `text`,
                  value: `Achieve a complete view of your customer`,
                },
              ],
              data: {},
              nodeType: BLOCKS.PARAGRAPH,
            },
          ],
          data: {},
          nodeType: BLOCKS.LIST_ITEM,
        },
        {
          content: [
            {
              content: [
                {
                  data: {},
                  marks: [],
                  nodeType: `text`,
                  value: `Unify your customers’ touch points across all platforms and channels`,
                },
              ],
              data: {},
              nodeType: BLOCKS.PARAGRAPH,
            },
          ],
          data: {},
          nodeType: BLOCKS.LIST_ITEM,
        },
        {
          content: [
            {
              content: [
                {
                  data: {},
                  marks: [],
                  nodeType: `text`,
                  value: `Enable compliant and consented data use`,
                },
              ],
              data: {},
              nodeType: BLOCKS.PARAGRAPH,
            },
          ],
          data: {},
          nodeType: BLOCKS.LIST_ITEM,
        },
        {
          content: [
            {
              content: [
                {
                  data: {},
                  marks: [],
                  nodeType: `text`,
                  value: `Sync and activate data from your warehouse to all your destinations in real-time`,
                },
              ],
              data: {},
              nodeType: BLOCKS.PARAGRAPH,
            },
          ],
          data: {},
          nodeType: BLOCKS.LIST_ITEM,
        },
        {
          content: [
            {
              content: [
                {
                  data: {},
                  marks: [],
                  nodeType: `text`,
                  value: `Deliver personalized customer experiences`,
                },
              ],
              data: {},
              nodeType: BLOCKS.PARAGRAPH,
            },
          ],
          data: {},
          nodeType: BLOCKS.LIST_ITEM,
        },
      ],
      nodeType: BLOCKS.UL_LIST,
    },
  ],
  data: {},
  nodeType: BLOCKS.DOCUMENT,
}

const data: SignUpBaseProps = {
  audience: `marketing`,
  metadata: {
    title: `Create a Free Segment Workspace | Twilio Segment`,
    description: `Segment is the leading Customer Data Platform. Start collecting, cleaning, activating your data for free when you create a workspace.`,
  },
  hero: {
    heading: `Get started with a free Segment account`,
    copy: `Take a peek under the hood of the system that processes 400,000 events per second.
    Sign up now and get access to the ${process.env.INTEGRATION_COUNT}+ integrations, features, and capabilities, with setup as easy as 10 lines of code. See why more than 25,000 companies use Segment’s software and APIs to collect, clean, and activate their customer data.`,
    formId: `site-marketing-workspace`,
  },
  main: {
    heading: `Create your ultimate data foundation`,
    description,
  },
  playbook: {
    heading: `Improve efficiency with Twilio Segment`,
    description: `Learn how leading brands use Twilio Segment and empower their teams with quality data.`,
    testimonial: {
      text: `“Reverse ETL [from Twilio Segment] is enabling us to intelligently trigger personalized marketing campaigns based on information created by data scientists that were previously confined to analytics use cases. These new campaigns have shown increased loyalty, customer satisfaction and engagement with our developer data platform.”`,
      author: {
        name: `Alexandra Dimitriu`,
        title: `Senior Marketing Ops Manager at MongoDB`,
      },
      data: {
        rate: `100x`,
        sign: ``,
        text: `Increase in registration rates`,
        link: `https://segment.com/customers/mongodb/`,
      },
    },
    recipeLink: `https://segment.com/recipes/fill-gaps-warehouse-data-retl/`,
    steps: {
      title: `Borrow their playbook`,
      items: [
        {
          title: `Step 1`,
          description: `Set up Snowflake (or any data warehouse of your choice) as a source for Reverse ETL.`,
        },
        {
          title: `Step 2`,
          description: `Build a model to start pulling profile data and sending identity calls from your Snowflake (or other data warehouse) table directly into your Segment workspace.`,
        },
        {
          title: `Step 3`,
          description: `Setup Segment as a destination and map the table data as Identify or Track events.`,
        },
      ],
    },
  },
}

export default data
